/**
 * It makes tabs switchable. it finds corresponding tab-content by index
 * If that tab-content doesn't exist, tab can be clickable through the link
 */
export default function SwitchTabs(selector) {

	if (!document.querySelector(selector) || !document.querySelector(selector + ' .tabs')) {
		return;
	}

	const isEnabled = document.querySelector(selector + ' .tabs').classList.contains('disabled') === false;
	const tabs = document.querySelectorAll(selector + ' .tabs > div');
	const tabContents = document.querySelectorAll(selector + ' .tab-content');
	const activeTab = document.querySelector(selector + ' .tabs > div.active');
	const activeTabIndex = Array.from(tabs).indexOf(activeTab);

	tabs.forEach((tab, index) => {
		tab.addEventListener('click', (e) => {
			tabs.forEach(tab => tab.classList.remove('active'));
			tab.classList.add('active');
			if (tabContents[index] && isEnabled) {
				tabContents.forEach(tabContent => tabContent.classList.remove('active'));
				tabContents[index]?.classList.add('active');

				// if some element have .switchtab-only-tab-{index} class,
				// it will be shown only when the tab is active
				document
					.querySelectorAll('[class*="switchtab-only-tab-"]')
					.forEach(el => el.classList.add('none'));

				document
					.querySelectorAll('.switchtab-only-tab-' + index)
					.forEach(el => el.classList.remove('none'));

				e.stopPropagation();
				e.preventDefault();
			}
		});
	});

	if (activeTabIndex > -1) {
		tabContents.forEach(tabContent => tabContent.classList.remove('active'));
		tabContents[activeTabIndex]?.classList.add('active');
	}

}
